import * as z from 'zod';

import { emailSchema } from '@/_schemas/generic';

export const loginFormSchema = z.object({
  email: emailSchema(false),
  password: z.string().min(1, 'Password is required'),
});

export type LoginFormSchema = z.infer<typeof loginFormSchema>;

export const LOGIN_FORM_DEFAULT_VALUES: LoginFormSchema = {
  email: '',
  password: '',
};
